import { AlertCircle, RefreshCw, Trash2 } from "lucide-react";
import { Button } from "@/components/ui";
import { cn } from "@/lib/utils";

/**
 * MessageError - Shows error state for failed optimistic messages
 * Provides retry and delete actions for failed message submissions
 */
export function MessageError({
  messageId,
  threadId,
  error,
  onRetry,
  onDelete,
  className,
}) {
  return (
    <div
      className={cn(
        "flex items-center space-x-3 px-4 py-3 rounded-lg",
        "bg-destructive/10 border border-destructive/30",
        "text-destructive",
        className
      )}
    >
      {/* Error icon */}
      <AlertCircle className="w-5 h-5 flex-shrink-0" />

      {/* Error message */}
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium">Failed to send message</p>
        {error && (
          <p className="text-xs text-muted-foreground mt-0.5 truncate">
            {error}
          </p>
        )}
      </div>

      {/* Action buttons */}
      <div className="flex items-center space-x-2 flex-shrink-0">
        {/* Retry button */}
        {onRetry && (
          <Button
            variant="ghost"
            size="sm"
            className="h-8 px-3 text-destructive hover:text-destructive hover:bg-destructive/20"
            onClick={() => onRetry(messageId, threadId)}
            aria-label="Retry sending message"
          >
            <RefreshCw className="w-4 h-4 mr-1.5" />
            Retry
          </Button>
        )}

        {/* Delete button */}
        {onDelete && (
          <Button
            variant="ghost"
            size="sm"
            className="h-8 px-3 text-destructive hover:text-destructive hover:bg-destructive/20"
            onClick={() => onDelete(messageId, threadId)}
            aria-label="Delete failed message"
          >
            <Trash2 className="w-4 h-4" />
          </Button>
        )}
      </div>
    </div>
  );
}

export default MessageError;
